import { Link, useLocation } from 'react-router-dom';
import { Home, Calendar, ClipboardList, List, MapPin, PackageSearch } from 'lucide-react';

const navItems = [
  { path: '/dashboard/home', icon: Home, label: 'Home' },
  { path: '/dashboard/personal', icon: Calendar, label: 'Schedule' },
  { path: '/dashboard/attendance', icon: ClipboardList, label: 'Attendance' },
  { path: '/dashboard/browse', icon: List, label: 'Browse' },
  { path: '/dashboard/rooms', icon: MapPin, label: 'Rooms' },
  { path: '/dashboard/lost-found', icon: PackageSearch, label: 'Lost & Found' },
];

export function DesktopNav() {
  const location = useLocation();

  return (
    <nav aria-label="Dashboard navigation" className="hidden md:flex lg:hidden min-w-0 flex-1 items-center gap-1 overflow-x-auto mx-4">{/* Show only on tablet, hide on mobile and desktop */}
      {navItems.map((item) => {
        const isActive = location.pathname === item.path;
        const Icon = item.icon;

        return (
          <Link key={item.path} to={item.path} aria-current={isActive ? 'page' : undefined}
              className={`flex shrink-0 items-center gap-2 px-3 py-2 rounded-xl transition-all ${
                isActive 
                  ? 'bg-primary/10 text-primary' 
                  : 'text-muted-foreground hover:text-foreground hover:bg-primary/5'
              }`}
            >
              <Icon className="w-4 h-4" aria-hidden />
              <span className="text-sm font-medium">{item.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
